<template>
	<div class="pages">
		<sub-ibox-title><p slot="title">关键词管理</p></sub-ibox-title>
		<section class="fx filter-wapper">
			<div class="fx fx-wrap fx-fill">
			</div>
			<div class="fx-shrink"><z-search v-model="params.search" placeholder="请输入关键词..." @handleSearch="handleGetList"></z-search></div>
			
		</section>
		<section>
			<z-table :offset="params.offset" :count="params.count" :total-count="list.item_total" @handleOffset="handleGetList">
				<th slot="columns" v-for="item in columns">{{item}}</th>
				<tr slot="datasource" v-for="(item, index) in list.list || []">
					<td>{{item.keywords}}</td>
					<td>{{item.reply_type | filterMaterialType}}</td>
					<td>{{item.l_time | momentFmt}}</td>
					<td class="operating">
						<a @click="handleEditLink(item)"  class="operat-btn"><i class="icon-edit"></i><span>编辑</span></a>
						<!--<a @click="handleDeleteKeywords(item.id,item.keywords)" class="operat-btn"><i class="icon-del"></i><span>删除</span></a>-->
						<el-popover placement="top" width="200" :ref="'popover_'+index">
							<div class="z-popover">
								<div>删除此关键词不可恢复哦! 继续删除?</div>
								<div @click="handleClosePopover(index)" class="pop-btns-cont">
									<a class="pop-btn-cancle">取消</a>
									<a @click="handleDeleteKeywords(item.id)" class="pop-btn-confirm">确定</a>
								</div>
							</div>
							<a class="operat-btn" slot="reference"><i class="icon-del"></i><span>删除</span></a>
						</el-popover>
					</td>
				</tr>
				<!--<tr slot="datasource" v-show="list.list.length <=0">
					<td colspan="20" ><p class="p-20">暂无关键词数据喔,赶紧添加吧！</p></td>
				</tr>-->
				<div slot="operate">
					<router-link class="z-btn z-btn-primary b-r-3" :to="{ name: 'wxKeyWordsEdit'}" >添加关键词</router-link>
				</div>
			</z-table>
		</section>
	</div>
</template>
<script>
	import { mapActions, mapState } from 'vuex'
	export default {
		name: 'WxKeyWords',
		components: {
		},
		data() {
			return {
				columns :['关键词','回复类型','最后操作时间','操作'],
				params:{
					offset:0,//分页偏移量
					count:10 //每页多少条
				}
			}
		},
		mounted() {
			this.handleGetList()
		},
		/*
		 * 属性计算
		 */
		computed: {
			...mapState({
				list: state => state.keywords.list
			})
		},
		/*
		 * 事件处理
		 */
		methods: {
			//关闭popover
			handleClosePopover(index) {
				if(typeof(this.$refs['popover_' + index]) != "undefined") this.$refs['popover_' + index][0].doClose();
			},
			handleEditLink(item){//编辑
				this.$setSessionStorage('KEY_WORDS_ITEM',item)
				this.$router.push({ name: 'wxKeyWordsEdit', query: { id:item.id }})
			},
			async handleDeleteKeywords(id){//删除关键词
				try{
					await this.deleteKeywords({id})
					this.handleGetList(this.params.offset)
					this.$success('删除成功')
					
				}catch(e){
					this.$log(e)
					if(e !='cancel') this.$errorMsg('删除失败')
				}
				
			},
			handleGetList(offset = 0){//获取关键词
				this.params.offset = offset
				this.getKeywordsList(this.params)
			},
			...mapActions(['getKeywordsList','deleteKeywords'])
		},
	}

</script>
<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// WxKeyWords.vue?0576d319